import React, { Component, PropTypes } from 'react';
import Helmet from 'react-helmet';
import { orderBy, forEach, filter } from 'lodash';
import pluralize from 'pluralize';
import formatCredits from '../../utils/formatCredits';

import connect from '../../utils/connect';
import baseUrl from '../../utils/baseUrl';

import ContentBlock from './block/content';
import Spinner from '../svg/spinner';
import InputText from '../form/input/text';
import Dropdown from '../dropdown/dropdown';

import Image from '../image/image';

import axios from 'axios';
import qs from 'qs';
import { dispatchError } from '../../actions/errors';

import { redirectToPathIf } from '../../utils/authorization';
import { accountRoute, FWA_ADMIN } from '../../routes';

import icMail from '../form/wysiwyg/icon-mail.png';
import css from './juryOverview.scss';

class AccountJuryOverview extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		users: PropTypes.object.isRequired,
		dispatch: PropTypes.func.isRequired,
	};

	constructor(props) {
		super(props);

		this.mounted = true;
		this.state = {
			waiting: true,
			items: [],
			showMore: false,
			sortBy: 'id',
			sortOrder: 'desc',
			filter: '',

			// judge details
			userId: false,
			userShowing: false,
			waitingUser: false,
			userItems: [],
		};
	}

	componentWillMount() {
		// redirectToAccountIfNoProfile(this.props.dispatch, this.props.users);
		redirectToPathIf(this.props.dispatch, accountRoute('/login'), this.props.users.canHas(FWA_ADMIN), true);

		axios({
			url: `${baseUrl}/api/account/admin/jury-overview`,
			method: 'get',
			responseType: 'json',
		})
		.then((res) => {
			const newState = {
				...this.state,
				waiting: false,
			};
			if (res.data && res.data.users) {
				newState.items = res.data.users;
			} else {
				this.props.dispatch(dispatchError('Invalid data received.'));
			}

			if (this.mounted) {
				this.setState(newState);
			}
		})
		.catch((res) => {
			if (res.data && res.data.message) {
				// this.props.dispatch(dispatchError(res.data));
			}

			if (this.mounted) {
				this.setState({
					...this.state,
					waiting: false,
				});
			}
		});
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let listClass = 'account-cases__list-container';
		let loadmoreClass = 'related-cases__load-more span8 span100p-mobile pixel-pattern';
		if (this.state.showMore) {
			listClass += ' account-cases__list-container--active';
			loadmoreClass += ' active';
		}

		const isMobile = this.props.browser.window.width < 719;

		const regex = new RegExp(this.state.filter, 'i');
		const filteredItems = filter(this.state.items, (item) => {
			if (this.state.filter) {
				return regex.test(item.name);
			}

			return true;
		})

		const judges = orderBy(filteredItems, [this.state.sortBy], [this.state.sortOrder]);

		const fieldRepresentation = {
			name: { name: 'Name', sortable: 1 },
			daysSinceLastVote: { name: 'Last vote', sortable: 1 },
			votesMonth: { name: <span><span className='hide-mobile'># votes</span> last 30 days</span>, sortable: 1 },
			scoreAverageMonth: { name: 'Average Score', sortable: 1 },
			email: { name: 'Mail', sortable: 0 },
		};
		const fieldKeys = Object.keys(fieldRepresentation);
		let fields = [];

		fieldKeys.map((key) => {
			let className = key;
			if (this.state.sortBy === key) {
				if (this.state.sortOrder === 'desc') {
					className += ' sort';
				} else {
					className += ' sort sort--asc';
				}
			}

			fields.push({
				key,
				field: fieldRepresentation[key],
				props: {
					className,
					onClick: () => (fieldRepresentation[key].sortable ? this.sortBy(key) : false),
				},
			});

			return true;
		});

		if (isMobile) {
			fields = fields.filter((item) => (item.key !== 'votesMonth' && item.key !== 'email'));
		}

		return (
			<div className='account-cases'>
				<Helmet title='The FWA - Account - Projects' />

				<ContentBlock title={'Jury overview'} sticky={false} browser={this.props.browser} className="account-block-content account-block-content--fixed-height account-block-content--title-head">
					<div className='account-block-content__content__buttons'>
						<InputText name='filter' placeholder='Filter' value={this.state.filter} onChange={(val) => this.setState({ ...this.state, filter: val })} />
					</div>
				</ContentBlock>

				{(this.state.waiting) && this.renderWaiting()}

				{(!this.state.waiting) && (
					<div className={listClass}>
						<div className='jury-overview__block span14'>
							<table sortable className='jury-overview__table'>
								<thead>
									<tr className='jury-overview__table__head'>
										{fields.map((item, i) => (
											<th key={item.key} {...(i === 0 ? { colSpan: 2 } : {})} {...item.props}>{item.field.name}</th>
										))}
									</tr>
								</thead>
								<tbody>
									{judges.map((item) => {
										const items = [(
											<tr key={item.id} className='jury-overview__table__item'>
												<td colSpan='2' className='jury-overview__table__item__name' onClick={() => this.fetchInfo(item.id)}>
													{item.name}
													{(this.state.waitingUser === item.id) && (
														<Spinner size='14' className='jury-overview__table__item__waiting' />
													)}
												</td>

												<td>{item.daysSinceLastVote !== null ? `${item.daysSinceLastVote} ${pluralize('days', item.daysSinceLastVote || 0)} ago` : '-'}</td>
												{(!isMobile) && (<td>{`${item.votesMonth} ${pluralize('votes', item.votesMonth || 0)}`}</td>)}
												<td>{item.scoreAverageMonth ? `${item.scoreAverageMonth} ${pluralize('pts', item.scoreAverageMonth || 0)}.` : '-'} </td>
												{(!isMobile) && (
													<td className='jury-overview__table__item__email'>
														<div ref={`drop${item.id}`}>
															<img {...icMail} alt='' className='jury-overview__table__item__email__icon' />
														</div>

														<Dropdown key='dropdown' attachTo={() => this.refs[`drop${item.id}`]} pointTo='AUTO' browser={this.props.browser} width={200}>
															<ol key='dropdown-ol'>
																<li key='link-mail-temp1'>
																	<a onClick={() => this.sendMail(item, 1)}>
																		Send template 1 (activity)
																	</a>
																</li>
																<li key='link-mail-temp2'>
																	<a onClick={() => this.sendMail(item, 2)}>
																		Send template 2 (scoring)
																	</a>
																</li>
																<li key='link-mailto'>
																	<a href={`mailto:${item.email}`}>
																		Send mail (manual)
																	</a>
																</li>
															</ol>
														</Dropdown>
													</td>
												)}
											</tr>
										)];

										if (this.state.userId === item.id && this.state.userShowing) {
											items.push((
												<tr key={`${item.id}--details`} className='jury-overview__table__item jury-overview__table__item--details jury-overview__table__item--details--head pixel-pattern pixel-pattern--darker'>
													<td>Thumb</td>
													<td colSpan='2'>Case</td>
													<td>{`${item.name.split(' ')[0]}'s score`}</td>
													{(!isMobile) && (<td>Case score</td>)}
													{(!isMobile) && (<td className='erase'></td>)}
												</tr>
											));

											forEach(this.state.userItems, (judgeItem) => {
												items.push((
													<tr key={`${judgeItem.id}--details-${1}`} className='jury-overview__table__item jury-overview__table__item--details'>
														<td className='jury-overview__table__item__image pixel-pattern pixel-pattern--darker'>
															<Image
																browser={this.props.browser}
																img={judgeItem.thumbnail}
																span={{ desktop: 'span3', tablet: 'span5', mobile: 'span14' }}
															/>
														</td>
														<td colSpan='2' className='jury-overview__table__item__case'>
															<span className='jury-overview__table__item__case__title'>{judgeItem.title}</span>
															{formatCredits(judgeItem.profiles)}
														</td>
														<td>{judgeItem.judgeScored} {pluralize('pts', judgeItem.points)}.</td>
														{(!isMobile) && (<td>{judgeItem.points} {pluralize('pts', judgeItem.points)}.</td>)}
														{(!isMobile) && (<td className='erase'></td>)}
													</tr>
												));
											});

											if (!this.state.userItems.length) {
												items.push((
													<tr key="empty" className='jury-overview__table__item jury-overview__table__item--details'>
														<td colSpan='5' className='jury-overview__table__item__case'>
															No votes registered in the past 30 days.
														</td>
														<td className='erase'></td>
													</tr>
												));
											}
										}

										return items;
									})}
								</tbody>
							</table>
						</div>

						<div className='cf'></div>
					</div>
				)}

				<div className='cf'></div>

			</div>
		);
	}

	sendMail(judge, templateId) {
		if (window.confirm(`Are you sure you want to mail this judge? ${judge.name}`)) {
			axios.post(`${baseUrl}/api/account/admin/jury-overview/mail/`, qs.stringify({
				judge: judge.id,
				template: templateId,
			}))
			.then((res) => {

			})
			.catch((res) => {
				if (res.data && res.data.message) {
					this.props.dispatch(dispatchError(res.data));
				}
			});
		}
	}

	fetchInfo(id) {
		const newState = {
			...this.state,
			waitingUser: id,
		};

		// if user requested is the one we already have fetched just toggle showing instead..
		if (this.state.userId === id) {
			newState.userShowing = !this.state.userShowing;
			newState.waitingUser = false;

			return this.setState(newState);
		}

		this.setState(newState);

		axios({
			url: `${baseUrl}/api/account/admin/jury-overview/${id}`,
			method: 'get',
			responseType: 'json',
		})
		.then((res) => {
			const newState2 = {
				...this.state,
				waitingUser: false,
			};
			if (res.data && res.data.cases) {
				newState2.userItems = res.data.cases;
				newState2.userId = id;
				newState2.userShowing = true;
			} else {
				this.props.dispatch(dispatchError('Invalid data received.'));
			}

			if (this.mounted) {
				this.setState(newState2);
			}
		})
		.catch((res) => {
			if (res.data && res.data.message) {
				this.props.dispatch(dispatchError(res.data));
			}

			if (this.mounted) {
				this.setState({
					...this.state,
					waitingUser: false,
				});
			}
		});

		return true;
	}

	sortBy(field) {
		if (!field || typeof field !== 'string') {
			return false;
		}

		const newState = { ...this.state };

		newState.sortBy = field;

		if (this.state.sortBy === field && this.state.sortOrder === 'desc') {
			newState.sortOrder = 'asc';
		} else {
			newState.sortOrder = 'desc';
		}

		return this.setState(newState);
	}

	setWaiting(state) {
		this.setState({ ...this.state, waiting: state });
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}

	toggleMore() {
		this.setState({
			...this.state,
			showMore: !this.state.showMore,
		});
	}
}

export default connect(AccountJuryOverview);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/juryOverview.js
 **/